import { getCLS, getFID, getFCP, getLCP, getTTFB } from 'web-vitals';

const reportWebVitals = (onPerfEntry?: (metric: unknown) => void) => {
    if (onPerfEntry) {
        getCLS(onPerfEntry);
        getFID(onPerfEntry);
        getFCP(onPerfEntry);
        getLCP(onPerfEntry);
        getTTFB(onPerfEntry);
    }

    // Development performance logging
    if (process.env.NODE_ENV === 'development') {
        console.log('🚀 Performance monitoring enabled');
        console.log('📊 Web Vitals will be reported to console');
    }
};

export default reportWebVitals;
